export default "__VITE_ASSET__B8jOFG$f__"